import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DocumentShouldBeToKsefWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Info, 'business.document.sale.validation.ksef-document.document-should-be-to-ksef');
    }
}
